import React from 'react';
import { Pencil } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const classificationOptions = [
  { id: 'activity', label: 'Documentar Actividad', color: 'bg-blue-100 text-blue-800' },
  { id: 'account_history', label: 'Historial de Cuenta', color: 'bg-purple-100 text-purple-800' },
  { id: 'relationship_history', label: 'Historial de Relación', color: 'bg-green-100 text-green-800' },
  { id: 'tasks', label: 'Generar Tareas', color: 'bg-amber-100 text-amber-800' }
];

const VoiceNoteCategory = ({ 
  category, 
  onRecategorize,
  isEditor 
}) => {
  const getCategoryInfo = (classifiedAs) => {
    const option = classificationOptions.find(opt => opt.id === classifiedAs);
    return option || { label: 'Pendiente', color: 'bg-gray-100 text-gray-800' };
  };

  const categoryInfo = getCategoryInfo(category);

  return (
    <Card data-testid="category-card">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Categoría</CardTitle>
          {isEditor && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onRecategorize}
              data-testid="recategorize-btn"
            >
              <Pencil className="w-3 h-3 mr-1" />
              Cambiar
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <Badge className={categoryInfo.color} data-testid="category-badge">
          {categoryInfo.label}
        </Badge>
        {isEditor && (
          <p className="text-xs text-muted-foreground mt-2">
            Procesar con IA
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export { classificationOptions };
export default VoiceNoteCategory;
